module.exports = __webpack_public_path__ + "static/media/girl.d681ac4e.png";